import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import  { SwitchProps } from '@mui/material/Switch';
import { Card, CardContent, InputLabel, FormControl, TextField, Box, Button, Typography, Checkbox, Select, MenuItem, Switch, Menu, Tooltip, LinearProgress } from "@mui/material";
import {
    agentIcon, audioIcon, copyIcon, dragIcon, greenDeleteIcon, hangupIcon, listenIcon, pauseIcon, phoneIcon, playIcon, speakIcon, transIcon, undoIcon, voiceIcon, mouseactionIcon,
    scrapIcon,
    projectIcon,
    screendataIcon,
    screenshotIcon,
    calldataIcon,
    pauseTypeIcon,
    resetIcon,
    inresetIcon,
    intrash,
    scessors,
    clickIcon,
    enterTextIcon,
    findItemIcon,
    loadPageIcon,
    mouseOverIcon,
    shotIcon,
    switchFrameIcon,
    pauseItemIcon,
    deleteIcon,
} from '../assets';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { useDrag, useDrop } from 'react-dnd'
import DensityMediumIcon from '@mui/icons-material/DensityMedium';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { ISegment, ISegmentLanguage, ISegmentStep } from '../types/interfaces/segment.interface';
import { useSelector } from 'react-redux';
import { getEditSegment, getSelectedSegments } from '../store/selectors/segment.selector';
import { getSuperUiConfigValueByName } from '../store/selectors/app.selector';
import { useAppDispatch } from '../store/hooks';
import { addNewSegment, removeSegment, setBatchSegments, setEditSegment, updateSegment, upsertLibrary } from '../store/resuders/segment.reducer';
import { getCurrentProject, getCurrentTestCase, getLanguages, selectBrowsers } from '../store/selectors/project.selector';
import { getTestCaseRunState } from '../store/selectors/run.selector';
import { CHANNELS, CONFIGNAME, DIGITAL_STEP_TYPE, RUN_STATUS, STEP_TYPE, TESTCASE_RUN_STATUS } from '../types/global.enum';
import { useFormik } from 'formik';
import { globalNotification, toggleAlert, toggleSpinner, triggerProjectTestCasesRefresh } from '../store/resuders/app.reducer';
import { ITestCase } from '../types/interfaces/testCase.interface';
import { getLastRunResult, getTestCaseById, getTranscriptionFile, hasMultiVariable, manualTestCaseRun, runDigitalTestCases, runStatusStream, runStatusStreamDigital, transcription, upsertDigitalTestCase, upsertTestCase, upsertComment, upsertNotes } from '../services/testcase.service';
import { setCurrentTestCase } from '../store/resuders/project.reducer';
import { Modal } from '../ui';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import InsertCommentIcon from '@mui/icons-material/InsertComment';
import { orderBy, uniqueId } from 'lodash';
import { copyTextToClipboard } from '../helpers/form.helper';
import { useTranslation } from 'react-i18next';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { findVariables, searchVariable } from '../services/grammar.service';
import { getVoiceApi } from '../services/config.service';
import { upsertSegment } from '../services/segment.service';
import { playFailedAudio } from '../services/audio.service';
import { useNavigate } from 'react-router-dom';
import EditNoteIcon from '@mui/icons-material/EditNote';
import Richtexteditor from '../ui/Richtexteditor';
import LibraryBooksRoundedIcon from '@mui/icons-material/LibraryBooksRounded';
import PublicIcon from '@mui/icons-material/Public'
import { Height } from '@mui/icons-material';
import { testRunStop } from '../services/testresults.service';
import { setTestCaseRunState, clearTestCaseRunState, buildRunKey } from '../store/resuders/run.reducer';
import CircularProgress from '@mui/material/CircularProgress';


export const NewTestCase = ({ toggleSegmentEditor, data = null, setSegmentAddTestCaseEditor, setremoveselectdEditSegmentSaveasNew , setEditSegmentfromCaseEditor, setShowWarning, showwarning, editorSource, setFromAddaSegment, setshowEditorwarning, autoSaveTrigger, setAutoSaveTrigger, onAutoSaveComplete}: { toggleSegmentEditor: (close?: boolean, open?: boolean) => void, data?: any, setSegmentAddTestCaseEditor: (value: boolean) => void; setremoveselectdEditSegmentSaveasNew: (value: number) =>void; setEditSegmentfromCaseEditor : (value: boolean) => void; setShowWarning  : (value: boolean) => void; showwarning : (value: boolean) => void; editorSource?: string; setFromAddaSegment: (value: boolean) => void; setshowEditorwarning : (value: boolean) => void; autoSaveTrigger: number; setAutoSaveTrigger : (value: number)  => void; onAutoSaveComplete: () => void; }) => {   
    const { t } = useTranslation();
    const navigate = useNavigate();
    const stream = useRef<EventSource>();
    const [removeSegments, setRemoveSegment] = React.useState<number[]>([]);
    const [varContents, setVarContents] = React.useState<any>({});
    const [runAll, setRunAll] = React.useState<boolean>(false);
    const segments = useSelector(getSelectedSegments);
    const [testCase, setTestCase] = useState<ITestCase | null>(null);
    const [triggerSave, setTriggerSave] = useState<boolean>(false);
    const dispatch = useAppDispatch();
    const languages = useSelector(getLanguages);
    const project = useSelector(getCurrentProject);
    const [addSegment, setAddSegment] = useState(false);
    const [lastRunResult, setLastRunResult] = useState<any>(null);
    const [runStatus, setRunStatus] = useState<TESTCASE_RUN_STATUS>(TESTCASE_RUN_STATUS.NONE);
    const [activeRunEngine, setActiveRunEngine] = useState<string | null>(null);
    const currentTestCase = useSelector(getCurrentTestCase);
    const { testCaseId } = useParams<{ testCaseId: string }>(); // Extract testCaseId from the URL
    const editMode = useSelector(getEditSegment);
    const run = useRef<ISegment[] | null>(null);
    const requestId = useRef<string>('');
    const [trans, setTrans] = useState<any>({});
    const [currentAudioId, setCurrentAudioId] = useState<any>(null);
    const [openReminder, setOpenReminder] = useState('')
    const [openaddComment, setOpenAddComment] = useState('')
    const [openaddNotes, setOpenAddNotes] = useState('')
    const [runParameter, setRunParameter] = useState('')
    const [iterationCount, setIterationCount] = useState(0)
    const [hasMultipleVariables, setHasMultipleVariables] = useState(false)
    const [pendingRunEngine, setPendingRunEngine] = useState<string | null>(null);
    const [audio, setAudio] = useState<any>(null);
    const [playingAudio, setPlayingAudio] = useState<boolean>(false);
    const [orderChanged, setOrderChanged] = useState<string>('');
    const [openSelectBrowser, setOpenSelectBrowser] = useState<string>('');
    const [browsersToRun, setBrowsersToRun] = useState<string[]>([]);
    const allIterationCount  = useRef<any>(null);
    const browsers = useSelector(selectBrowsers);
    const [ Commentshowwarning , setCommentshowwarning] = useState<boolean>(false);
    const [ Noteshowwarning , setNoteshowwarning] = useState<boolean>(false);
    const [ContinueOnFailIsChecked, setContinueOnFailIsChecked] = useState<boolean>(false);
    const [caseRunId, setCaseRunId] = useState<number | null>(null);
    const activeRunKey = useRef<string>('');
    const [loading,isLoading] = useState<boolean>(false);
    const currentRunState = useSelector(
        getTestCaseRunState(
            currentTestCase?.projectId || 0,
            Number(testCaseId)
        )
    );
    const streamTimeoutRaw = useSelector(getSuperUiConfigValueByName(CONFIGNAME.STREAM_TIMEOUT));
    // configValue is in minutes (e.g. "60" = 60 min); convert to ms. Default: 10 min.
    const streamHeartbeatMs = streamTimeoutRaw ? Number(streamTimeoutRaw) * 60 * 1000 : 600000;

    const initializeDigitalStream = (reqId: string) => {
        // Close any existing stream before creating a new one
        if (stream.current) {
            stream.current.close();
        }

        const runKey = buildRunKey(
            testCase?.projectId || 1,
            Number(testCaseId) || 0
        );
        activeRunKey.current = runKey;
        console.log('[Digital Stream] Initializing stream. run.current length at init:', run.current?.length);

        const streamInstance = runStatusStreamDigital(reqId, streamHeartbeatMs);
        stream.current = streamInstance;

        streamInstance.onopen = () => {
            console.log('[Digital Stream] Connection opened');
        };
        streamInstance.onerror = (err: any) => {
            // Ignore errors from stale streams
            if (stream.current !== streamInstance) return;
            console.log('[Digital Stream] Stream error occurred, readyState:', streamInstance.readyState);
            streamInstance.close();
            activeRunKey.current = '';
            console.log('[Digital Stream] CLEARING from: onerror handler');

            dispatch(
                clearTestCaseRunState({
                    projectId: testCase?.projectId || 1,
                    testCaseId: Number(testCaseId) || 0,
                })
            );
        };
        streamInstance.onmessage = async (e: any) => {
            // Ignore messages from stale digital streams
            if (stream.current !== streamInstance) return;

            const currentKey = buildRunKey(
                testCase?.projectId || 1,
                Number(testCaseId) || 0
            );
            console.log('[Digital Stream] Message received. keyMatch:', activeRunKey.current === currentKey, 'run.current length:', run.current?.length);

            if (activeRunKey.current !== currentKey) {
                console.log('[Digital Stream] SKIPPING - key mismatch');
                return;
            }

            const data = JSON.parse(e.data);
            console.log('[Digital Stream] Parsed data. Stream segments:', data.segments?.length, 'testResult status:', data.testResult?.status);

            run.current = (run.current || []).map((seg, index) => {
                const currSegment = data.segments[index];
                const hasStatus = !!currSegment?.testResult?.status;
                if (hasStatus) {
                    scrollToel(index);
                    return {
                        ...seg,
                        testResult: currSegment?.testResult,
                        segmentLangs: seg.segmentLangs.reduce((lngs: ISegmentLanguage[], currLngs: ISegmentLanguage) => {
                            lngs.push({
                                ...currLngs,
                                steps: currLngs.steps?.reduce((rlt: ISegmentStep[], currStep: ISegmentStep) => {
                                    const res = currSegment?.steps?.find((stp: ISegmentStep) => stp.testStepId === currStep.testStepId);
                                    if (res) {
                                        rlt.push({
                                            ...currStep,
                                            testResult: {
                                                ...res.testResult,
                                                messageToPlay: res.messageToPlayOriginal !== res.messageToPlay ? '@'+res.messageToPlayOriginal?.replace(/@/g,'') + ' = ' + res.messageToPlay+'@' :res.messageToPlay,
                                            },
                                        });
                                    } else {
                                        rlt.push(currStep);
                                    }
                                    return rlt;
                                }, []),
                            });
                            return lngs;
                        }, []),
                        runStatus: currSegment?.testResult?.status,
                    };
                }
                return {
                    ...seg,
                };
            });
            isLoading(true);
            dispatch(setBatchSegments(run.current));
            isLoading(false);

            const msgStatuses = run.current.map(s => s.runStatus);
            const hasFailed = run.current.some(seg => seg.runStatus === RUN_STATUS.FAILED);
            const allSuccess = run.current.every(seg => seg.runStatus === RUN_STATUS.SUCCESS);
            console.log('[Digital Stream] After update - statuses:', msgStatuses, 'hasFailed:', hasFailed, 'allSuccess:', allSuccess);

            if (hasFailed) {
                console.log('[Digital Stream] Detected FAILED, stopping run');
                setRunStatus(TESTCASE_RUN_STATUS.STOPPED);
                activeRunKey.current = '';

                dispatch(
                    clearTestCaseRunState({
                        projectId: testCase?.projectId || 1,
                        testCaseId: Number(testCaseId) || 0,
                    })
                );
                await lastRun();
            } else if (allSuccess) {
                console.log('[Digital Stream] Detected all SUCCESS, finishing run');
                setRunStatus(TESTCASE_RUN_STATUS.FINISHED);
                activeRunKey.current = '';

                dispatch(
                    clearTestCaseRunState({
                        projectId: testCase?.projectId || 1,
                        testCaseId: Number(testCaseId) || 0,
                    })
                );
                await lastRun();
            }
        };
    };


    const initializeVoiceStream = async (reqId: string) => {
        //  Step 1: Close any existing stream before creating a new one
        if (stream.current) {
            stream.current.close();
        }
    
        const runKey = buildRunKey(testCase?.projectId || 1, Number(testCaseId) || 0);
        activeRunKey.current = runKey;
    
        //  Step 2: Track this stream using a unique Symbol
        const streamId = Symbol();
        isLoading(true);
        stream.current = await runStatusStream(reqId, streamHeartbeatMs);
        (stream.current as any).id = streamId;
        stream.current.onerror = (err: any) => {
            // Step 3: Ignore errors from old/stale streams
            if ((stream.current as any)?.id !== streamId) return;

            const readyState = (stream.current as any)?.readyState;
            console.log('[Voice Stream] onerror fired. readyState:', readyState, 'segments:', run.current?.map(s => ({ seq: s.segmentSeq, status: s.runStatus })));

            // readyState 0 (CONNECTING) = polyfill timed out on inactivity and is auto-reconnecting.
            // This happens during long silent steps 
            // Do NOT clear run state — the reconnected stream will continue delivering events.
            if (readyState === 0) {
                console.log('[Voice Stream] Polyfill reconnecting due to inactivity — ignoring, run continues');
                return;
            }

            // readyState 2 (CLOSED) = stream truly ended (server closed or network failure).
            // If any segment is still STARTED, the final message may have been lost in a race
            // with the server's onComplete(). Fetch the actual result from the server.
            const anyStillStarted = run.current?.some(seg => seg.runStatus === RUN_STATUS.STARTED);
            if (anyStillStarted) {
                console.log('[Voice Stream] Stream closed with segments still STARTED — fetching final result');
                lastRun();
            }
    
            stream.current?.close();
            activeRunKey.current = '';
    
            dispatch(clearTestCaseRunState({
                projectId: testCase?.projectId || 1,
                testCaseId: Number(testCaseId) || 0,
            }));
        };
    
        stream.current.onmessage = async (e: any) => {
            // Step 4: Ignore messages from old or outdated streams
            if ((stream.current as any)?.id !== streamId) return;
    
            const currentKey = buildRunKey(testCase?.projectId || 1, Number(testCaseId) || 0);
            if (activeRunKey.current !== currentKey) return;
    
            const data = JSON.parse(e.data);
    
            // Update segments (same as your logic)
            run.current = (run.current || []).map((seg, iii) => {
                const { id } = seg?.segmentLangs?.find(s => s.languageCode.id === seg.defaultLng) || {};
                if (id) {
                    const currSegment = data.segments.find((s: any) => +s.id === +id && +s.segmentSeq === +(seg.segmentSeq || 0));
                    if (currSegment?.testResult?.status) {
                        scrollToel(iii);
                        return {
                            ...seg,
                            testResult: currSegment?.testResult,
                            segmentLangs: seg.segmentLangs.map(currLngs => {
                                if (currLngs.languageCode.id === seg.defaultLng) {
                                    return {
                                        ...currLngs,
                                        steps: currLngs.steps?.map(currStep => {
                                            const res = currSegment?.steps?.find((stp: ISegmentStep) => stp.testStepId === currStep.testStepId);
                                            return res
                                                ? {
                                                      ...currStep,
                                                      testResult: {
                                                          ...res.testResult,
                                                          messageToPlay:
                                                              res.messageToPlayOriginal !== res.messageToPlay
                                                                  ? '@' +
                                                                    res.messageToPlayOriginal?.replace(/@/g, '') +
                                                                    ' = ' +
                                                                    res.messageToPlay +
                                                                    '@'
                                                                  : res.messageToPlay,
                                                      },
                                                  }
                                                : currStep;
                                        }),
                                    };
                                }
                                return currLngs;
                            }),
                            runStatus: currSegment?.testResult?.status,
                        };
                    }
                }
                return seg;
            });
    
            dispatch(setBatchSegments(run.current));
            isLoading(false);

            //  Step 5: Finish logic – only clear when run is complete
            
            if (run.current.some(seg => seg.runStatus === RUN_STATUS.FAILED)) {
                setRunStatus(TESTCASE_RUN_STATUS.STOPPED);
                activeRunKey.current = '';

                dispatch(
                    clearTestCaseRunState({
                        projectId: testCase?.projectId || 1,
                        testCaseId: testCase?.id || testCase?.testCaseId || 0,
                    })
                );
                await lastRun();
            } else if (run.current.every(seg => seg.runStatus !== RUN_STATUS.STARTED)) {
                setRunStatus(TESTCASE_RUN_STATUS.FINISHED);
                activeRunKey.current = '';

                dispatch(
                    clearTestCaseRunState({
                        projectId: testCase?.projectId || 1,
                        testCaseId: testCase?.id || testCase?.testCaseId || 0,
                    })
                );
                await lastRun();
            }
        };
    };
    

    const formik = useFormik({
        initialValues: {
            name: '',
            ivrPhoneNumber: '',
            callerId: '',
            remark: '',
            comment:'',
            notes: '',
            projectId: 0,
            testCaseWID: null,
            id: null,
            testCaseId: null,
            saveAsNew: false,
        },
        onSubmit: async values => {

            if(project?.data?.channelType === CHANNELS.VOICE) {
                if (!values || !values.name || !values.ivrPhoneNumber ) {
                    // Check if fields are empty/undefined
                    dispatch(toggleAlert("Please fill in all required fields."));
                    return;
                }
                // Check if fields are empty/whitespace
                if (!values.name.trim() || !values.ivrPhoneNumber.trim() ) {
                    dispatch(toggleAlert("Please fill in all required fields."));
                    return;
                }
            }


            dispatch(toggleSpinner(true));

            if(project?.data?.channelType === CHANNELS.DIGITAL) {
                const result = await upsertDigitalTestCase(segments, values.name, values?.comment, project?.testProjectID || 1, values?.saveAsNew ? null : values.testCaseId, false, values?.saveAsNew, values?.notes);
                dispatch(toggleSpinner(false));

                if (["ERR_BAD_RESPONSE", "ERR_BAD_REQUEST"].includes(result?.code)) {
                    dispatch(toggleAlert(result?.response?.data?.data?.messages?.join(',')))
                } else {
                    const { data } = await getTestCaseById(project?.testProjectID || 1, result?.data?.testCaseId || 0, project?.data?.channelType)(dispatch);
                    dispatch(setCurrentTestCase(data));
    
                    dispatch(globalNotification(values.testCaseId && !values?.saveAsNew ? 'The test case is updated.' : 'The new test case is created.'))
                    
                    // Trigger folder tree refresh for the project
                    dispatch(triggerProjectTestCasesRefresh({ projectId: project?.testProjectID || 1 }));
    
                }
                setTriggerSave(false);

                return;
            }

            const formData = {
                ...values,
                projectId: project?.testProjectID || 0,
                testCaseWID: values?.saveAsNew ? undefined : testCase?.testCaseWID,
                id: values?.saveAsNew ? undefined : testCase?.id,
                testCaseId: values?.saveAsNew ? undefined : testCase?.testCaseId,
                keepAliveIfFailed: ContinueOnFailIsChecked,
                segments: (segments || []).map((s: ISegment, index: number) => ({
                    testCaseSegmentId: values?.saveAsNew ? 0 : s.testCaseSegmentId || 0,
                    segmentSeq: index,
                    testSegmentId: s.segmentLangs.find(sl => sl.languageCode.id === s.defaultLng)?.id,
                    languageCode: s.defaultLng,
                    enabled: s.enabled,
                })),
            }

            const result = await upsertTestCase(project?.testProjectID, formData);

            dispatch(toggleSpinner(false));
            if (["ERR_BAD_RESPONSE", "ERR_BAD_REQUEST"].includes(result?.code)) {
                dispatch(toggleAlert(result?.response?.data?.data?.messages?.join(',')))
            } else {
                const testCase = result?.data?.data as ITestCase;
                const { data } = await getTestCaseById(testCase.projectId || 1, testCase.testCaseId || 0, project?.data?.channelType)(dispatch);
                dispatch(setCurrentTestCase(data));

                dispatch(globalNotification(formData.id || formData.testCaseId ? 'The test case is updated.' : 'The new test case is created.'))
                
                // Trigger folder tree refresh for the project
                dispatch(triggerProjectTestCasesRefresh({ projectId: project?.testProjectID || 0 }));

            }
            setTriggerSave(false);
        },
    })

    const scrollToel = (index:number)=> {
        const el = document.getElementById(`segment_row_${index}`);

        if(el) {
            el.scrollIntoView({  block: "start" });
        }
    }

    const updateSegmentLanguage = (seg: ISegment) => (e: any) => {
        dispatch(updateSegment({
            ...seg,
            defaultLng: e.target.value,
        }));
        setTriggerSave(true);
    }

    const deleteTest = () => {
        dispatch(removeSegment(removeSegments));

        setRemoveSegment([]);
        setTriggerSave(true);
    }

    const addComment = () => {
        setOpenAddComment(uniqueId());
    }

    const handleAddComment = async () => {
        if(testCase?.testCaseId){
            upsertComment(testCase?.projectId || 1, testCase?.testCaseId || 0, formik.values.comment)
            .then((response) => {
                dispatch(toggleAlert(response.data));
                dispatch({ type: 'COMMENT_UPSERT_SUCCESS', payload: response });
            })
            .catch((error) => {
                dispatch({ type: 'COMMENT_UPSERT_FAILURE', payload: error });
            });
            setTriggerSave(false);
            if (currentTestCase.name !== formik.values?.name ||
                currentTestCase.ivrPhoneNumber !== formik.values?.ivrPhoneNumber ||
                currentTestCase.callerId !== formik.values?.callerId ||
                currentTestCase.segments?.length !== segments?.length ||
                langChanged()) {
                
                setTriggerSave(true);
            }
            
            setOpenAddComment("");  
        }else{
            setOpenAddComment("");
        }
        
    }

    
    const addNotes = () => {
        setOpenAddNotes(uniqueId());
    }

    const handleAddNotes = () => {

        if(testCase?.testCaseId){
            upsertNotes(testCase?.projectId || 1, testCase?.testCaseId || 0, formik?.values?.notes)
            .then((response) => {
                dispatch({ type: 'NOTES_UPSERT_SUCCESS', payload: response });
                dispatch(toggleAlert(response.data));
            })
            .catch((error) => {
                dispatch({ type: 'NOTES_UPSERT_FAILURE', payload: error });
            });
            setTriggerSave(false);
            if (currentTestCase.name !== formik.values?.name ||
                currentTestCase.ivrPhoneNumber !== formik.values?.ivrPhoneNumber ||
                currentTestCase.callerId !== formik.values?.callerId ||
                currentTestCase.segments?.length !== segments?.length ||
                langChanged()) {
                
                setTriggerSave(true);
            }
            
            setOpenAddNotes("");
        }else{
            setOpenAddNotes("");
        }

       
        
    }


    const undo = async () => {
        if (currentTestCase) {
            const { data } = await getTestCaseById(currentTestCase?.projectId || 1, Number(testCaseId) || 0, project?.data?.channelType)(dispatch);
            dispatch(setCurrentTestCase(data));
            setTriggerSave(false);
            setOrderChanged('');
        }
        setBrowsersToRun([]);
        scrollToel(0);
    }

    const handleAddSegment = () => {
        dispatch(setEditSegment(null));
        setAddSegment(!addSegment);
        toggleSegmentEditor(true);
        toggleSegmentEditor(false,true);
        setSegmentAddTestCaseEditor(true);
        setEditSegmentfromCaseEditor(false)
        setFromAddaSegment(true);
        
    };

    const saveTestCase = async () => {   
        setRunStatus(TESTCASE_RUN_STATUS.NONE);
        run.current = [];
        await formik.submitForm();
    };
    const handleSave = async () => {
        formik.setFieldValue('saveAsNew', false);
        setOrderChanged('');
        await saveTestCase();
    }

    const handleSaveAsNew = async () => {
        formik.setFieldValue('saveAsNew', true);
         await saveTestCase();
    }

    useEffect(() => {
        // alert(`AutoSave Triggered: ${autoSaveTrigger}`);
        if (autoSaveTrigger) {
            handleSave().then(() => {
                setshowEditorwarning(false);
                onAutoSaveComplete();
                setAutoSaveTrigger(0);
            });
        }
    }, [autoSaveTrigger]);

    const browserSelected = (e:any)=> {
        if(e.target.checked) {
            setBrowsersToRun(browsersToRun.concat(e.target.value))
        } else {
            setBrowsersToRun(browsersToRun.filter(b=> b!== e.target.value))
        }
    }

    const runDigital = async ()=> {
        console.log('[Digital Stream] runDigital called. browsersToRun:', browsersToRun.length, 'runStatus:', runStatus, 'hasActiveKey:', activeRunKey.current !== '');
        setRunParameter('');
        setHasMultipleVariables(false);
        setPendingRunEngine(null);
        if (browsersToRun.length > 0) {
           const runs =  await runDigitalTestCases(testCase?.projectId || 1, [{id:Number(testCaseId) || 0, runAll:allIterationCount.current ? true:false}], browsersToRun.join(','));
           console.log('[Digital Stream] runDigital: API response received, runs:', runs?.length);

           requestId.current = runs[0]?.data?.data;
           setRunStatus(TESTCASE_RUN_STATUS.STARTED);
           activeRunKey.current = buildRunKey(
               testCase?.projectId || 1,
               Number(testCaseId) || 0
           );
           console.log('[Digital Stream] runDigital: activeRunKey set, segments:', segments.length);
           setActiveRunEngine('digital');
           dispatch(
                setTestCaseRunState({
                    projectId: testCase?.projectId || 1,
                    testCaseId: Number(testCaseId) || 0,
                    state: {
                        requestId: requestId.current,
                        status: TESTCASE_RUN_STATUS.STARTED,
                        runEngine: 'digital',
                    },
                })
            );

           run.current = segments.map((seg, index) => (
            {
                ...seg,
                segmentLangs: seg.segmentLangs.map(sl => ({
                    ...sl,
                    steps: sl.steps?.map(stp => ({
                        ...stp,
                        testResult: null,
                    })),
                })),
                runStatus: index === 0 ? RUN_STATUS.STARTED : RUN_STATUS.NONE
            }
        )) as ISegment[];

        const runStatuses = run.current.map(s => s.runStatus);
        console.log('[Digital Stream] runDigital: run.current set, statuses:', runStatuses);
        dispatch(setBatchSegments(run.current));
        initializeDigitalStream(requestId.current);

            setOpenSelectBrowser('');
        } else {
            console.log('[Digital Stream] runDigital: browsersToRun is empty, not running');
        }
    }

    const abortTestCase = async () => {
        if (runStatus === TESTCASE_RUN_STATUS.STARTED) {
            const { data } = await testRunStop(caseRunId || 0);
            if (data === 'Done') {
                dispatch(toggleAlert('Test Case Run Aborted Successfully.'));
                stream.current?.close();
                await undo();
            } else {
                dispatch(toggleAlert(data?.message || 'Failed to stop the test case run.'));
            }
            setRunStatus(TESTCASE_RUN_STATUS.STOPPED);
            activeRunKey.current = '';
            setActiveRunEngine(null);
            setPendingRunEngine(null);

            dispatch(
                clearTestCaseRunState({
                    projectId: testCase?.projectId || 1,
                    testCaseId: Number(testCaseId) || 0,
                })
            );
            setRunStatus(TESTCASE_RUN_STATUS.NONE);

        }
    }


    const runTestCaseWithVariation = (ivrEngine: string | null = null) => async () => {
        const normalizedEngine = ivrEngine || 'nvp';
        setPendingRunEngine(normalizedEngine);
        // Check if at least one segment is enabled
        const isAnySegmentEnabled = segments.some((segment) => segment.enabled);

        if (!isAnySegmentEnabled) {
            // Display an error message if all segments are disabled
            dispatch(toggleAlert('At least one segment must be enabled to run the test case.'));
            setPendingRunEngine(null);
            return; // Stop execution if validation fails
        }
        if([TESTCASE_RUN_STATUS.FINISHED, TESTCASE_RUN_STATUS.STOPPED].includes(runStatus)) {
            setRunStatus(TESTCASE_RUN_STATUS.NONE)
            if(project?.data?.channelType === CHANNELS.DIGITAL) {
                setOpenSelectBrowser(uniqueId());
                return;
            }
            await runTestCase(true, normalizedEngine)();
        } else {
            const {iterationCount, numMultiValueVariables} = await hasMultiVariable(testCase?.projectId || 1, testCase?.id || testCase?.testCaseId || 0, project?.data?.channelType);

            // If any multi-value variables exist (iterationCount > 1), show the modal
            if(iterationCount > 1) {
                setIterationCount(iterationCount);
                // Disable ALL option if multiple variables have multiple values
                if(numMultiValueVariables > 1) {
                    setHasMultipleVariables(true);
                    allIterationCount.current = false;
                    setRunAll(false);
                } else {
                    setHasMultipleVariables(false);
                }
                setRunParameter(uniqueId());
            } else {
                // No multi-value variables, just run directly
                if(project?.data?.channelType === CHANNELS.DIGITAL) {
                    if (runStatus !== TESTCASE_RUN_STATUS.NONE) {
                        setRunStatus(TESTCASE_RUN_STATUS.NONE);
                        await undo();
                        setPendingRunEngine(null);
                        return;
                    }
                    setOpenSelectBrowser(uniqueId());
                    return;
                }

                await runTestCase(true, normalizedEngine)();
            }
        }

    }

    const setItCount = (e:any)=> {
        allIterationCount.current = (e.target.checked);
        setRunAll(e.target.checked);
    }

    const runTestCase = (start: boolean, ivrEngine: string | null = null) => async () => {
        setRunParameter('');
        setHasMultipleVariables(false);
        if (start) {
            // if (runStatus !== TESTCASE_RUN_STATUS.NONE) {
            //     setRunStatus(TESTCASE_RUN_STATUS.NONE);
            //     await undo();
            //     return;
            // }
            setLastRunResult(null);

            dispatch(toggleSpinner(true));
            dispatch(setEditSegment(null));
            const { data } = await manualTestCaseRun(Number(testCaseId) || 0, testCase?.projectId || 1, allIterationCount.current ? 'all':'default', ivrEngine || 'nvp');
            dispatch(toggleSpinner(false));

            if (data?.data && data?.code === "success") {
                requestId.current = data.data.requestId;
                setCaseRunId(data.data.caseRunId);
                const normalizedEngine = ivrEngine || 'nvp';
                setRunStatus(TESTCASE_RUN_STATUS.STARTED);
                setActiveRunEngine(normalizedEngine);
                setPendingRunEngine(null);
                activeRunKey.current = buildRunKey(
                    testCase?.projectId || 1,
                    Number(testCaseId) || 0
                );
                dispatch(
                    setTestCaseRunState({
                        projectId: testCase?.projectId || 1,
                        testCaseId: Number(testCaseId) || 0,
                        state: {
                            requestId: requestId.current,
                            status: TESTCASE_RUN_STATUS.STARTED,
                            caseRunId: data.data.caseRunId,
                            runEngine: normalizedEngine,
                        },
                    })
                );

                run.current = segments.map((seg, index) => (
                    {
                        ...seg,
                        segmentLangs: seg.segmentLangs.map(sl => ({
                            ...sl,
                            steps: sl.steps?.map(stp => ({
                                ...stp,
                                testResult: null,
                            })),
                        })),
                        runStatus: index === 0 ? RUN_STATUS.STARTED : RUN_STATUS.NONE
                    }
                )) as ISegment[];
                dispatch(setBatchSegments(run.current));
                initializeVoiceStream(requestId.current);
            } else {
                return;
            }

        }
    }


    const reorderSegments = (item: any, targetIndex: number) => {
        
        if(item.index === undefined) {
            //If segment is dropped from Segment tab
            dispatch(addNewSegment(item));
            let result = [...segments];
            result.splice(targetIndex, 0, item)
            const seg = result.reduce((res: ISegment[], curr: ISegment, index: number) => {
                res.push({
                    ...curr,
                    segmentSeq: index + 1,
                });
                return res;
            }, []);
            dispatch(setBatchSegments(orderBy(seg, 'segmentSeq')));
            setTriggerSave(true);
            setOrderChanged(uniqueId());
        } else if (item.index !== targetIndex) {
            let result = [...segments];
            const temp = segments[item.index];
            result.splice(item.index, 1);
            result.splice(targetIndex, 0, temp);

            const seg = result.reduce((res: ISegment[], curr: ISegment, index: number) => {
                res.push({
                    ...curr,
                    id:`${curr.id}`,
                    segmentSeq: index + 1,
                });
                return res;
            }, []);

            dispatch(setBatchSegments(orderBy(seg, 'segmentSeq')));
            setTriggerSave(true);
            setOrderChanged(uniqueId());
        }
    }

    const segmentSelectionChanged = (index: number) => (e: any) => {
        if (e.target.checked) {
            setRemoveSegment(removeSegments.concat(index))
        } else {
            setRemoveSegment(removeSegments.filter(c => c !== index))

        }
    }

    const handleToggleSegmentEnabled = (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {

        const updatedSegments = [...segments];
        updatedSegments[index] = {
          ...updatedSegments[index],
          enabled: event.target.checked, // or `isActive` or whatever flag you use
        };
        dispatch(setBatchSegments(updatedSegments))
        setTriggerSave(true);
      };

    const editSegment = (seg: ISegment, lang?: ISegmentLanguage, step?: ISegmentStep, sub?: string, index?: number) => () => {
        setremoveselectdEditSegmentSaveasNew(index ?? -1)
        setSegmentAddTestCaseEditor(true);
        setEditSegmentfromCaseEditor(true)
        setFromAddaSegment(false);
        dispatch(upsertLibrary(''));
        dispatch(setEditSegment({
            segment: seg,
            step,
            lang,
            sub,
        }))

        setAddSegment(true);
        toggleSegmentEditor(false, true);
    }

    useEffect(() => {
        if (project) {
            formik.setFieldValue('projectId', project.testProjectID);
        }

        return ()=> {
            if(stream.current) {
                stream.current?.close();
            }
        }
    }, [project]);

    const handleLastRunResult = () => {
        // Navigate to the details (L3) page for the most recent run of this testcase
        const pid = project?.data?.testProjectID || testCase?.projectId;
        const tcId = testCase?.testCaseId || lastRunResult?.testCaseId;
        const runId = lastRunResult?.testResult?.id;
        if (pid && tcId && runId) {
            // Use the folders view route to navigate in the current tab
            navigate(`/folders/project/${pid}/testresults/${tcId}/${runId}`);
            //navigate(`/folders/project/${pid}/testresults/${tcId}/${runId}`);
        } else {
            console.error('Cannot navigate to detailed run result: missing project, testcase, or run ID');
        }
    }


    const lastRun = async () => {
        const { data } = await getLastRunResult(currentTestCase.projectId, Number(testCaseId), project?.data?.channelType);
        if (data?.data) {
            setLastRunResult(data.data);
        }
    }

    useEffect(() => {
        setTestCase(currentTestCase);
        setContinueOnFailIsChecked(currentTestCase?.keepAliveIfFailed || false);
        formik.setValues({
            ...(currentTestCase || {}),
        })

        if (currentTestCase) {
            lastRun();
            
        } else {
            setLastRunResult(null);
        }
        // reset state and close active stream when switching test cases
        // Skip reset if a digital run is actively streaming (activeRunKey is set)
        const isDigitalRunActive = project?.data?.channelType === CHANNELS.DIGITAL && activeRunKey.current !== '';
        console.log('[Digital Stream] currentTestCase useEffect fired. isDigitalRunActive:', isDigitalRunActive, 'hasActiveKey:', activeRunKey.current !== '', 'channelType:', project?.data?.channelType);
        if (!isDigitalRunActive) {
            console.log('[Digital Stream] CLEARING from: currentTestCase useEffect');
            run.current = null;
            requestId.current = '';
            setRunStatus(TESTCASE_RUN_STATUS.NONE);
            setCaseRunId(null);
            activeRunKey.current = '';
            stream.current?.close();
        }
    }, [currentTestCase]);

    useEffect(() => {
        // Use activeRunKey ref (not runStatus state) because setRunStatus hasn't flushed yet when this fires
        const isDigitalRunActive = project?.data?.channelType === CHANNELS.DIGITAL && activeRunKey.current !== '';
        console.log('[Digital Stream] currentRunState useEffect fired. isDigitalRunActive:', isDigitalRunActive, 'runStatus:', runStatus, 'lastRunResult status:', lastRunResult?.testResult?.status, 'hasActiveKey:', activeRunKey.current !== '');
        if(lastRunResult && lastRunResult?.testResult?.status !== 'RUNNING' && !isDigitalRunActive){
            console.log('[Digital Stream] CLEARING from: currentRunState useEffect (lastRunResult branch)');
            run.current = [];
            requestId.current = '';
            activeRunKey.current = '';
        }else{

            if(runStatus === TESTCASE_RUN_STATUS.NONE && currentRunState?.status === TESTCASE_RUN_STATUS.STARTED && String(currentTestCase.testCaseId) === String(testCaseId)) {
                requestId.current = currentRunState.requestId;
                setCaseRunId(currentRunState?.caseRunId || null);
                setRunStatus(TESTCASE_RUN_STATUS.STARTED);
                setActiveRunEngine(currentRunState?.runEngine || 'nvp');
                setPendingRunEngine(null);
                activeRunKey.current = buildRunKey(
                    currentTestCase.projectId || 1,
                    Number(testCaseId) || 0
                );
                run.current = segments.map((seg, index) => ({
                    ...seg,
                    segmentLangs: seg.segmentLangs.map(sl => ({
                        ...sl,
                        steps: sl.steps?.map(stp => ({ ...stp }))
                    })),
                    runStatus: index === 0 ? RUN_STATUS.STARTED : RUN_STATUS.NONE
                })) as ISegment[];
    
                dispatch(setBatchSegments(run.current));
                if(project?.data?.channelType === CHANNELS.DIGITAL) {
                    initializeDigitalStream(requestId.current);
                } else {
                    initializeVoiceStream(requestId.current);
                }
            }else{
                // If the run status is not NONE, it means we are in the middle of a run
                // so we don't want to reset the run.current state
                // Skip clearing if a digital run is actively streaming
                const isDigitalActive = project?.data?.channelType === CHANNELS.DIGITAL && activeRunKey.current !== '';
                if (runStatus !== TESTCASE_RUN_STATUS.NONE && !isDigitalActive) {
                    console.log('[Digital Stream] CLEARING from: currentRunState useEffect (else branch, runStatus:', runStatus, ')');
                    run.current = [];
                    requestId.current = '';
                    activeRunKey.current = '';
                }
            }
        }
       
    }, [currentRunState]);


    useEffect(() => {
        if (runStatus !== TESTCASE_RUN_STATUS.STARTED) {
            setActiveRunEngine(null);
        }
    }, [runStatus]);


    const getRunStatusStyle = (status?: RUN_STATUS) => {

        switch (status) {
            case RUN_STATUS.STARTED: return 'run-status';
            case RUN_STATUS.SUCCESS: return 'run-status-pass';
            case RUN_STATUS.FAILED: return 'run-status-fail';
        }
        return runStatus === TESTCASE_RUN_STATUS.NONE ? '' : 'all-run';
    }

    const downloadScreenshot = (url: string) => () => {
        window.open(url);
    }

    const playAudioFile = (url: string) => async () => {
        setAudio(new Audio(`${getVoiceApi().replace('/api/voice/v1', '')}/${url}`));
        setCurrentAudioId(url)
    }

    const playTrans = (stepId?: number) => async () => {

        if (currentAudioId !== stepId) {
            const blob = await playFailedAudio(stepId);
            setAudio(new Audio(blob));
        } else if (!playingAudio && audio) {
            audio.play();
            setPlayingAudio(true);
        } else if (playingAudio) {
            setPlayingAudio(false);
            audio.pause();
        } else {
            const blob = await playFailedAudio(stepId);
            setAudio(new Audio(blob));
        }

        setCurrentAudioId(stepId);
    }

    const TranslateStepTypes = ({ seg = null as ISegment | null, lang = null as ISegmentLanguage | null, step = null as ISegmentStep | null }) => {

        if (!seg || !lang || !step) return null;
        let icon = hangupIcon;
        let text = '';

        switch (step?.stepType) {
            case STEP_TYPE.TRANSFER_CALL_TO_AGENT: { text = 'Transfer to Agent'; icon = agentIcon; break; }
            case STEP_TYPE.SCREEN_SHOT: { text = 'Screen Shot'; icon = screenshotIcon; break; }
            case STEP_TYPE.GET_CALL_DATA: { text = 'Get Call Data'; icon = calldataIcon; break; }
            case STEP_TYPE.SCREENSCRAPE_DATA: { text = 'Get Screen Data'; icon = scrapIcon; break; }
            case STEP_TYPE.MOUSE_ACTION: { text = 'Mouse Action'; icon = mouseactionIcon; break; }
            case STEP_TYPE.ENTER_SCREEN_DATA: { text = 'Enter Screen Data'; icon = screendataIcon; break; }
            case STEP_TYPE.HANGUP: { text = 'Hang Up'; break; }
        }

        return (
            <div className='speech hang'>
                <div className='hangup' onClick={editSegment(seg, lang, step)}>
                    <img src={icon} alt="" />{text}
                </div>
            </div>
        )
    }

    useEffect(() => {
        if (audio) {

            audio.addEventListener('ended', () => {
                setPlayingAudio(false);
                setAudio(null);
            });

            setPlayingAudio(true);
            audio.play();
        }

    }, [audio])

    const getFailedListenFile = (seg: ISegment, step: ISegmentStep, lang: ISegmentLanguage) => async () => {
        if (seg?.testResult?.id && step.testResult?.id) {
            if (!trans[`${seg?.testResult?.id}-${step.testResult?.id}`]) {
                const { data } = await transcription(seg?.testResult?.id, step.testResult?.id, seg?.defaultLng || 'english');

                if (data?.code === 'success') {
                    setTrans({
                        ...trans,
                        [`${seg?.testResult?.id}-${step.testResult?.id}`]: data?.data?.transcript,
                    })
                } else {

                }
            } else {

                copyTextToClipboard(trans[`${seg?.testResult?.id}-${step.testResult?.id}`]);

                if (step.stepType === STEP_TYPE.LISTEN) {
                    setOpenReminder(uniqueId());
                }

                editSegment(seg, lang, {
                    ...step,
                    stepType: step.stepType === STEP_TYPE.LISTEN_ANYTHING || step.stepType === STEP_TYPE.LISTEN_BETA || step.stepType === STEP_TYPE.LISTEN_CONTEXT_ALIGNMENT ? STEP_TYPE.LISTEN : step.stepType,
                    prompt: step.stepType === STEP_TYPE.LISTEN_ANYTHING || step.stepType === STEP_TYPE.LISTEN_BETA || step.stepType === STEP_TYPE.LISTEN_CONTEXT_ALIGNMENT ? trans[`${seg?.testResult?.id}-${step.testResult?.id}`] : step.prompt,
                })();

                if (step.stepType === STEP_TYPE.LISTEN_ANYTHING || step.stepType === STEP_TYPE.LISTEN_BETA || step.stepType === STEP_TYPE.LISTEN_CONTEXT_ALIGNMENT) {

                    setTimeout(() => {
                        editSegment(seg, lang, {
                            ...step,
                            stepType: step.stepType === STEP_TYPE.LISTEN_ANYTHING || step.stepType === STEP_TYPE.LISTEN_BETA || step.stepType === STEP_TYPE.LISTEN_CONTEXT_ALIGNMENT ? STEP_TYPE.LISTEN : step.stepType,
                            prompt: step.stepType === STEP_TYPE.LISTEN_ANYTHING || step.stepType === STEP_TYPE.LISTEN_BETA || step.stepType === STEP_TYPE.LISTEN_CONTEXT_ALIGNMENT ? trans[`${seg?.testResult?.id}-${step.testResult?.id}`] : step.prompt,
                        })();
                    }, 300);

                }


            }

        }
    }

    const getTransIcon = (segId?: number, stepId?: number) => {
        return !trans[`${segId}-${stepId}`] ? transIcon : copyIcon;
    }

    const getTranscription = (segId?: number, stepId?: number) => {
        return trans[`${segId}-${stepId}`] || '';
    }

    const langChanged = () => {
        let changed = false;
        currentTestCase.segments?.forEach((seg: any) => {
            const f = segments?.find(s => s.segmentSeq === seg.segmentSeq);

            if (!f) {
                changed = true;
                return;
            } else if (f && f.defaultLng !== seg.languageCode) {
                changed = true;
                return;
            }
        });

        return changed;
    }

    const segmentsChanged = () => {

        let changed = false;
        currentTestCase.segments?.forEach((seg: any) => {
            const f = segments?.find(s => s.segmentSeq === seg.segmentSeq);
           
            if (!f) {
                changed = true;
                return;
            } else if (f && f.enabled !== seg.enabled) {
                changed = true;
                return;
            }
        });

        return changed;
       
    };
    useEffect(() => {
        if (orderChanged) {
            setTriggerSave(true);
            setshowEditorwarning(true);
            return;
        }
        if (!currentTestCase) {
            if (formik.values.name && segments?.length) {
                setTriggerSave(true);
                setshowEditorwarning(true);
            } else {
                setTriggerSave(false);
                setshowEditorwarning(false);
                setNoteshowwarning(false);
            }
        
        } else {
            
            if (currentTestCase.name !== formik.values?.name ||
                currentTestCase.ivrPhoneNumber !== formik.values?.ivrPhoneNumber ||
                currentTestCase.callerId !== formik.values?.callerId ||
                currentTestCase.segments?.length !== segments?.length ||
                segmentsChanged() ||
                currentTestCase.comment !== formik.values?.comment ||
                currentTestCase.notes !== formik.values?.notes ||
                currentTestCase.keepAliveIfFailed !== ContinueOnFailIsChecked ||
                langChanged()) {
                
                setTriggerSave(true);
                setshowEditorwarning(true);
                if (
                    typeof formik.values?.comment !== "undefined" &&
                    currentTestCase.comment !== formik.values.comment
                  ) {
                    setCommentshowwarning(true);
                }
                if(
                    typeof formik.values?.notes !== "undefined" &&
                    currentTestCase.notes !== formik.values?.notes){
                    setNoteshowwarning(true);
                }
            } else {
                setTriggerSave(false);
                setshowEditorwarning(false);
                setNoteshowwarning(false);
            }
        }
    }, [currentTestCase, formik.values, segments, orderChanged, ContinueOnFailIsChecked]);


    const SegmentItem = ({ ...props }) => {
        const [{ isOver }, drops] = useDrop(() => ({
            accept: 'SEGMENT-ROWS',
            drop: (item: any) => reorderSegments(item, props.data.index),
            collect: (monitor: any) => ({
                isOver: !!monitor.isOver(),
            }),
        }))

        const [{ isDragging }, drag] = useDrag(() => ({
            type: 'SEGMENT-ROWS',
            item: {
                ...props.data,
                order: true,
            },
            collect: (monitor: any) => ({
                isDragging: !!monitor.isDragging(),
            }),
        }))

        const ref = useRef<any>(null);
        drag(drops(ref))

        return (<div style={isOver ? { backgroundColor: '#CECECE' } : {}} ref={ref} data-handler-id={props.data.lang.id} className="relative show-drag pointer">
            <img src={dragIcon} alt="" className={"drag-icon left--5 none"} />

            {props.children}
        </div>);
    }

    const addSegmentFromLibrary = (item: ISegment | any) => {
        item.enabled = true; // Ensure the segment is enabled when added from library
        if (localStorage.getItem('LibraryEditorSource') === "GlobalLibrary") {
            item.global = true; // Add the global property if editorSource is "Global Library"
        }else{
            item.global = false; // Add the global property if editorSource is not "Global Library"
        }

        dispatch(addNewSegment(item));
       
        setTriggerSave(true);
    }

    const [{ isOver }, drop] = useDrop(() => ({
        accept: 'SEGMENT-ROWS',
        drop: addSegmentFromLibrary,
        collect: (monitor: any) => ({
            isOver: !!monitor.isOver(),
        }),
        hover: (item: any, monitor) => {
            
        }
    }), [segments])

    const loadVars = (name:string)=>async()=> {
        if(varContents?.[name]) return;

        const d = await searchVariable(testCase?.projectId || 1, name.replace(/@/g, ''));
        setVarContents({
            ...varContents,
            [name]:d,
    })
    }
   
    const renderDigitalStep  =(step:ISegmentStep)=> {
        const map = {
            [DIGITAL_STEP_TYPE.CLICK]:clickIcon,
            [DIGITAL_STEP_TYPE.ENTER_TEXT]:enterTextIcon,
            [DIGITAL_STEP_TYPE.FIND_ITEM]:findItemIcon,
            [DIGITAL_STEP_TYPE.LOAD_PAGE]:loadPageIcon,
            [DIGITAL_STEP_TYPE.MOUSE_OVER]:mouseOverIcon,
            [DIGITAL_STEP_TYPE.PAUSE]:pauseItemIcon,
            [DIGITAL_STEP_TYPE.SCREENSHOT]:shotIcon,
            [DIGITAL_STEP_TYPE.SWITCH_FRAME]:switchFrameIcon,
        } as any;

        return <img src={map[step.actionType || '']} alt="" />;
    }

    const insertStep = (where:'ABOVE' | 'BELOW', seg:ISegment, lang:ISegmentLanguage, index:number, popupState:any) => ()=> {
        const data = segments.reduce((segs:ISegment[], currSegment:ISegment)=> {
            if(currSegment.id == seg.id) {
                segs.push({
                    ...currSegment,
                    segmentLangs: currSegment.segmentLangs.reduce((lngs:ISegmentLanguage[], currLang:ISegmentLanguage)=> {
                        if(currLang.id == lang.id) {
                           let stepSeq = 0;
                            lngs.push({
                                ...currLang,
                                steps : (currLang.steps || []).reduce((steps:ISegmentStep[], currStep:ISegmentStep, i:number) => {
                                    if(index === -1 && i === 0) {
                                        steps.push({
                                            stepSeq:stepSeq+1,
                                        });
                                        ++stepSeq;
                                        steps.push({
                                            ...currStep,
                                            stepSeq:stepSeq+1,
                                        });
                                    } else if(index === i) {
                                        steps.push({
                                            ...currStep,
                                            stepSeq:stepSeq+1,
                                        });
                                        ++stepSeq;
                                        steps.push({
                                            stepSeq:stepSeq+1,
                                        });
                                    } else {
                                        steps.push({
                                            ...currStep,
                                            stepSeq:stepSeq+1,
                                        });
                                    }

                                    ++stepSeq;
                                    return steps;
                                },[])
                            })
                        } else {
                            lngs.push(currLang);
                        }
                        return lngs;
                    },[])
                });
                
            } else {
                segs.push(currSegment);
            }

            return segs;
        },[]);
        dispatch(setBatchSegments(data))
        
        popupState.close();

        editSegment(data.find(d=>d.id == seg.id) || seg, data.find(d=>d.id == seg.id)?.segmentLangs[0], {stepSeq: where === 'ABOVE' ?  index+2:index+2})()
    }

    const reorderSteps = ( direction:'UP' | 'DOWN', seg:ISegment, lang:ISegmentLanguage, index:number, popupState:any)=> async ()=> {

        const data = segments.reduce((segs:ISegment[], currSegment:ISegment)=> {
            if(currSegment.id == seg.id) {
                segs.push({
                    ...currSegment,
                    segmentLangs: currSegment.segmentLangs.reduce((lngs:ISegmentLanguage[], currLang:ISegmentLanguage)=> {
                        if(currLang.id == lang.id) {
                            lngs.push({
                                ...currLang,
                                steps : (currLang.steps || []).reduce((steps:ISegmentStep[], currStep:ISegmentStep, i:number) => {

                                    if(direction === 'UP') {
                                        steps.push({
                                            ...currStep,
                                            stepSeq: i>index ? currStep.stepSeq: (i+1 === index ? (currStep.stepSeq || 0)+1:(i===index ? (currLang.steps?.[index]?.stepSeq || 0)-1:i)),
                                        });
                                    } else {
                                        steps.push({
                                            ...currStep,
                                            stepSeq: i<index ? currStep.stepSeq: (i-1 === index ? (currStep.stepSeq || 0)-1:(i===index ?  (currLang.steps?.[index]?.stepSeq || 0)+1:i)),
                                        });
                                    }
                                    return orderBy(steps,ss=>ss.stepSeq)
                                },[])
                            })
                        } else {
                            lngs.push(currLang);
                        }
                        return lngs;
                    },[])
                });
                
            } else {
                segs.push(currSegment);
            }

            return segs;
        },[]);

        if(project?.data?.channelType === CHANNELS.VOICE) {
            await upsertSegment(project?.data?.testProjectID, data.find(s=>s.id == seg.id));
        }

        dispatch(setBatchSegments(data))
        
        popupState.close();
    }

    
    const handleContinueOnFailisChecked = (event: React.ChangeEvent<HTMLInputElement>) => {
        setContinueOnFailIsChecked(event.target.checked); // Update state based on the switch's checked value
      };

    
      const SegmentDisableSwitch = styled(Switch)(({ theme }) => ({
        width: 40,
        height: 35,
        margin: 2,

        '& .MuiSwitch-thumb': {
          width: 14,
          height: 14,
        },
        '& .MuiButtonBase-root.MuiSwitch-switchBase': {
            padding: '10px 4px'
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
          color: '#006a68',
          
        },
        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
          backgroundColor: '#006a68',
          
        },
      }));

    

    const ContinueOnFailSwitch = styled(Switch)(({ theme }) => ({
        width: 57,
        height: 34,
        padding: 6,
        top: 4,
        
        '& .MuiSwitch-track': {
          borderRadius: 22 / 2,
          backgroundColor: '#006a68',
          '&::before, &::after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            width: 14,
            height: 14,
            
          },
          '&::before': {
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="15" width="15" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
              theme.palette.getContrastText(theme.palette.primary.main),
            )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
            left: 12,
          },
          '&::after': {
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
              theme.palette.getContrastText(theme.palette.primary.main),
            )}" d="M19,13H5V11H19V13Z" /></svg>')`,
            right: 12,
          },
        },
        '& .MuiSwitch-thumb': {
          boxShadow: 'none',
          width: 14,
          height: 14,
          margin: 2,
          backgroundColor: '#006a68',
          top: 6,
        },
        '& .MuiButtonBase-root.MuiSwitch-switchBase': {
            color: '#ddd', // Custom color for the unchecked state
            '& .MuiSwitch-thumb': {
            backgroundColor: '#444', // Change thumb color when unchecked
            },
            '& + .MuiSwitch-track': {
            backgroundColor: 'rgba(0, 0, 0, 0.6)', // Change track color when unchecked
            },
        },
        '& .MuiButtonBase-root.MuiSwitch-switchBase.Mui-checked': {
            color: '#006a68', // Custom color for the checked state
            '& .MuiSwitch-thumb': {
              backgroundColor: '#006a68', // Change thumb color when checked
            },
            '& + .MuiSwitch-track': {
              backgroundColor: '#006a68', // Change track color when checked
            },
        },
      }));



    return (
        <Card className="h-100-p">
            <CardContent>
                <div className="test-case-container">
                    <Box className="test-case-input">
                        <FormControl sx={{ width: "100%" }}>
                            <InputLabel id="test-case-name"></InputLabel>
                            <TextField
                                label={t("Test Case Name")}
                                id="name"
                                name="name"
                                value={formik.values?.name}
                                onChange={formik.handleChange}
                                InputLabelProps={{ shrink: Boolean(formik.values?.name) }}
                                multiline
                                minRows={1}
                                maxRows={4}
                                sx={{
                                    '& .MuiInputBase-root': {
                                        paddingTop: '8px',
                                        paddingBottom: '8px'
                                    }
                                }}
                            />
                        </FormControl>
                    </Box>
                    <Box className="test-case-input">
                        
                    <Tooltip title={ "Test Case Description" } ><InsertCommentIcon style={{ fontSize: '25px', color: formik.values?.comment ? '#006a68' : 'rgb(187 187 187)'  , margin: "auto" }} onClick={addComment}/></Tooltip>
                    <Tooltip title={ "NOTES" } ><EditNoteIcon style={{ fontSize: '25px', color: formik.values?.notes ? '#006a68' : 'rgb(187 187 187)'  , margin: "auto" }} onClick={addNotes}/></Tooltip>
                    <img className='pointer' src={!removeSegments?.length ? intrash : deleteIcon} onClick={deleteTest} />
                    <img className='pointer' src={!currentTestCase || !triggerSave ? inresetIcon : resetIcon} onClick={undo} />
                    <FormGroup>
                    <Tooltip title="Continue On Fail" arrow>
                        <FormControlLabel
                            control={<ContinueOnFailSwitch 
                                checked={ContinueOnFailIsChecked} // Bind the state to the switch
                                onChange={handleContinueOnFailisChecked} // Handle the change event
                                 />}
                            label=""
                        />
                         </Tooltip>
                     </FormGroup>  
                        {project?.data?.channelType === CHANNELS.VOICE && 
                            <>
                                <FormControl sx={{ width: "40%" }}>
                                    <InputLabel id="test-case-clid"></InputLabel>
                                    <TextField
                                        id="callerId"
                                        name="callerId"
                                        value={formik.values?.callerId}
                                        onChange={formik.handleChange}
                                        label={t("CLID")}
                                        InputLabelProps={{ shrink: Boolean(formik.values?.callerId) }}
                                    />
                                </FormControl>
                                <FormControl sx={{ width: "50%" }}>
                                    <InputLabel id="test-case-number"></InputLabel>
                                    <TextField
                                        id="ivrPhoneNumber"
                                        name="ivrPhoneNumber"
                                        value={formik.values?.ivrPhoneNumber}
                                        onChange={formik.handleChange}
                                        label={t("IVR Tel. Number")}
                                        InputLabelProps={{ shrink: Boolean(formik.values?.ivrPhoneNumber) }}
                                    />
                                </FormControl>
                            </>
                        }
                    </Box>

                    
                    <Box>
                           
                        <div className="test-case-display">
                        {!segments?.length ? (
                            <div className='no-segment' ref={drop}>
                                <div className='db w-100 pt-40'><AddCircleOutlineIcon onClick={handleAddSegment} style={{ fill: '#7D6C6C', fontSize: '51px' }} /></div>
                                <div className='db w-100 pt-15'><Typography variant='caption'>{t('Add a segment')}</Typography></div>
                            </div>
                        ) : (
                            <>
                            {loading &&
                                <LinearProgress /> 

                            }
                                {project?.data?.channelType === CHANNELS.DIGITAL && segments.map((seg: ISegment, indx: number)=>(
                                    <SegmentItem key={`seg_list_render_${indx}`} data={{ seg, lang:'', index: indx }}>
                                        <div id={`segment_row_${indx}`} className={'db seg-list ' + (indx === segments.length - 1 && runStatus !== TESTCASE_RUN_STATUS.FINISHED ? ' mb-80' : ' mb-16')} key={`segment_${indx}`}>
                                                 <div className='flex align-center'>
                                                 
                                                        {runStatus === TESTCASE_RUN_STATUS.NONE ? (
                                                            <Checkbox checked={removeSegments.includes(indx)}
                                                                onChange={segmentSelectionChanged(indx)} />) : (<div className={'circle-' + getRunStatusStyle(seg.runStatus)}>&nbsp;</div>)}
                                                          <span onClick={editSegment(seg)} className='segment-name-hover'>{t('Segment')} {indx + 1}: {seg.name}
                                                                {seg?.global ? (
                                                                    <PublicIcon titleAccess="Global Library Segment"  style={{ marginLeft: 4, marginBottom:2, fontSize: 14, color: '#2173d9' }} />
                                                                ) : (
                                                                    <LibraryBooksRoundedIcon titleAccess="Project Library Segment" style={{ marginLeft: 4, marginBottom:2, fontSize: 14 , color: 'rgb(0 106 104)'}} />
                                                                )}
                                                          </span>
                                                          <Tooltip title={ "Segment Disable" } >
                                                            <SegmentDisableSwitch
                                                            checked={!!seg.enabled}
                                                            onChange={handleToggleSegmentEnabled(indx)}
                                                            color="primary"
                                                          />
                                                        </Tooltip>
                                                        </div>
                                                    <div className={'progress-bar ' + getRunStatusStyle(seg.runStatus) + (editMode?.segment?.id == seg.id ? ' bar-edit' : '')}>&nbsp;</div>
                                                    
                                                    {(seg?.segmentLangs?.[0]?.steps || []).map((step: ISegmentStep, i: number) => (
                                                    <div key={`step_${i}`} className='relative'>
                                                         <div className='step-mover'><PopupState variant="popover" popupId="demo-popup-menu">
                                                                {(popupState) => (
                                                                    <React.Fragment>
                                                                    <DensityMediumIcon {...bindTrigger(popupState)} />
                                                                    <Menu {...bindMenu(popupState)}>
                                                                        <MenuItem onClick={insertStep('ABOVE',seg, seg?.segmentLangs?.[0], i-1, popupState)}>{t('Insert above')}</MenuItem>
                                                                        {i>0 && <MenuItem onClick={reorderSteps('UP', seg, seg?.segmentLangs?.[0], i, popupState)}>{t('Move up')}</MenuItem>}
                                                                        {i+1<(seg?.segmentLangs?.[0]?.steps?.length ?? 0) && <MenuItem onClick={reorderSteps('DOWN', seg, seg?.segmentLangs?.[0], i, popupState)}>{t('Move down')}</MenuItem>}
                                                                        <MenuItem onClick={insertStep('BELOW',seg, seg?.segmentLangs?.[0], i, popupState)}>{t('Insert below')}</MenuItem>
                                                                    </Menu>
                                                                    </React.Fragment>
                                                                )}
                                                                </PopupState></div>
                                                        <div className='speech hang flex-column'>
                                                            <div className='pause digital-steps' onClick={editSegment(seg, seg.segmentLangs[0], step)}>
                                                                <div>{renderDigitalStep(step)}</div>
                                                                <div>{t(step.actionType || '')}</div>
                                                            </div>

                                                            {step?.criteria?.map((c:any)=>(
                                                                <div className='digital-step-criteria' onClick={editSegment(seg, seg.segmentLangs[0], step)}>
                                                                   {'>> '} [{t(c.locatorType)}]
                                                                   <p>{c.attributeName || c?.elementName} [{c.operation}] [{c.attributeValue || c.displayText }]</p>
                                                                </div>
                                                            ))}

                                                            {step?.criteria2?.map((c:any)=>(
                                                                <div className='digital-step-criteria' onClick={editSegment(seg, seg.segmentLangs[0], step)}>
                                                                   {'>> '} [{t(c.locatorType)}]
                                                                   <p>{c.attributeName || c?.elementName} [{c.operation}] [{c.attributeValue || c.displayText}]</p>
                                                                </div>
                                                            ))}
                                                           
                                                        </div>
                                                    </div>
                                                    ))}
                                        </div>
                                    </SegmentItem>
                                ))}

                                {project?.data?.channelType === CHANNELS.VOICE && segments.map((seg: ISegment, indx: number) => (
                                    seg.segmentLangs.filter(l => l.languageCode.id === seg.defaultLng)
                                        .map((lang: ISegmentLanguage, index: number) => (
                                            <SegmentItem key={`seg_list_render_${seg.id}`} data={{ seg, lang, index: indx }}>
                                                <div id={`segment_row_${indx}`} className={'db seg-list ' + (indx === segments.length - 1 && runStatus !== TESTCASE_RUN_STATUS.FINISHED ? ' mb-80' : ' mb-16')} key={`segment_${index}`}>
                                                    <div className='flex align-center'>
                                                        {runStatus === TESTCASE_RUN_STATUS.NONE ? (
                                                            <Checkbox checked={removeSegments.includes(indx)}
                                                                onChange={segmentSelectionChanged(indx)} />) : (<div className={'circle-' + getRunStatusStyle(seg.runStatus)}>&nbsp;</div>)}
                                                        <span onClick={editSegment(seg, lang)} className='segment-name-hover'>{t('Segment')} {indx + 1}: {seg.name}
                                                        {seg?.global ? (
                                                                <PublicIcon titleAccess="Global Library Segment"  style={{ marginLeft: 4, marginBottom:2, fontSize: 14, color: '#2173d9' }} />
                                                            ) : (
                                                                <LibraryBooksRoundedIcon titleAccess="Project Library Segment" style={{ marginLeft: 4, marginBottom:2, fontSize: 14 , color: 'rgb(0 106 104)'}} />
                                                            )}
                                                        </span>
                                                        <Tooltip title={ "Segment Disable" } >
                                                            <SegmentDisableSwitch
                                                            checked={!!seg.enabled} // Bind the checked state to seg.enabled
                                                            onChange={handleToggleSegmentEnabled(indx)} // Handle toggle changes
                                                            color="primary"
                                                          />
                                                        </Tooltip>
                                                        </div>

                                                    <div className={'progress-bar ' + getRunStatusStyle(
                                                         seg.segmentLangs?.[0]?.steps?.some(step => step.testResult?.status === 'FAILED') // Check if any step has a FAILED status
                                                         ? RUN_STATUS.FAILED 
                                                         : seg.segmentLangs?.[0]?.steps?.[0]?.testResult?.status // Otherwise, use the first step's status
                   
                                                        ) + (editMode?.segment?.id == seg.id ? ' bar-edit' : '')}>
                                                        
                                                        &nbsp;</div>

                                                    {runStatus === TESTCASE_RUN_STATUS.NONE && (
                                                        <div className='db segment-language'>
                                                            <Select
                                                                value={seg.defaultLng || seg.segmentLangs?.[0]?.languageCode?.id}
                                                                label="Language"
                                                                name="language"
                                                                size='small'
                                                                className='min-w-150'
                                                                onChange={updateSegmentLanguage(seg)}
                                                            >
                                                                {seg.segmentLangs.filter(l => l.steps?.length).map(lng => (
                                                                    <MenuItem key={`opt_lng_${lng.id}`} value={lng?.languageCode?.id}>{languages.find((l: any) => l.id === (lng?.languageCode?.id || languages[0].id))?.name || ''}</MenuItem>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                    )}

                                                    {(lang.steps || []).map((step: ISegmentStep, i: number) => (
                                                        <div key={`step_${i}`} className='relative'>
                                                            <div className='step-mover'><PopupState variant="popover" popupId="demo-popup-menu">
                                                                {(popupState) => (
                                                                    <React.Fragment>
                                                                    <DensityMediumIcon {...bindTrigger(popupState)} />
                                                                    <Menu {...bindMenu(popupState)}>
                                                                    <MenuItem onClick={insertStep('ABOVE',seg, lang, i-1, popupState)}>{t('Insert above')}</MenuItem>
                                                                        {i>0 && <MenuItem onClick={reorderSteps('UP', seg, lang, i, popupState)}>{t('Move up')}</MenuItem>}
                                                                        {i+1<(lang?.steps?.length ?? 0) && <MenuItem onClick={reorderSteps('DOWN', seg, lang, i, popupState)}>{t('Move down')}</MenuItem>}
                                                                        <MenuItem onClick={insertStep('BELOW',seg, lang, i, popupState)}>{t('Insert below')}</MenuItem>
                                                                    </Menu>
                                                                    </React.Fragment>
                                                                )}
                                                                </PopupState></div>
                                                            {[STEP_TYPE.RECORD_VOICE, STEP_TYPE.LISTEN].includes(step.stepType || STEP_TYPE.NONE) ? (
                                                                <div onClick={editSegment(seg, lang, step, '', indx)} >
                                                                    <div className={'prompt flex' + (step.listenSubStep ? ' gap-8' : '') + (step.stepType === STEP_TYPE.RECORD_VOICE ? ' record-voice' : '')}>
                                                                        {step.listenSubStep?.some(c => c.name) ? (
                                                                            <div>
                                                                                <div  className='branching'>{step?.testResult?.voice?.listenSubstep ? `${step.stepSeq}${step?.testResult?.voice?.listenSubstep}` : step.stepSeq + 'A'}
                                                                                </div>
                                                                                <div>
                                                                                    <img src={step.stepType === STEP_TYPE.RECORD_VOICE ? voiceIcon : listenIcon} alt="" className="absolute top-15 pl-40" />
                                                                                </div>
                                                                            </div>
                                                                        ) : (
                                                                            <img src={step.stepType === STEP_TYPE.RECORD_VOICE ? voiceIcon : listenIcon} alt="" className="absolute top-15" />
                                                                        )}

                                                                        <div className='f-w-500 pl-30'>
                                                                            {t(step.stepType?.replace('RECORD_VOICE', 'Record Voice') || '')}
                                                                            <span className={'f-w-400 db ' + (step?.testResult?.status === RUN_STATUS.SUCCESS ? ' step-passed' : '')}
                                                                            dangerouslySetInnerHTML={{ __html: `${step.testResult && step?.testResult?.voice?.listenSubstep && step?.testResult?.voice?.listenSubstep !== 'A' ? step.listenSubStep?.find(l => l.name === step?.testResult?.voice?.listenSubstep)?.prompt :
                                                                            step.testResult && step?.testResult?.voice?.utterance ? step.testResult?.voice?.utterance : (step?.libraryItemIds?.length ?  step?.libraryItemIds?.map((s:any)=> s.textContent).join("<br/>"):step.prompt)}` }}>
                                                                            </span>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                [STEP_TYPE.HANGUP, STEP_TYPE.ENTER_SCREEN_DATA, STEP_TYPE.GET_CALL_DATA, STEP_TYPE.MOUSE_ACTION,
                                                                STEP_TYPE.SCREENSCRAPE_DATA, STEP_TYPE.SCREEN_SHOT, STEP_TYPE.TRANSFER_CALL_TO_AGENT].includes(step.stepType || STEP_TYPE.NONE) ? (
                                                                    <>
                                                                        <TranslateStepTypes seg={seg} lang={lang} step={step} />
                                                                    </>
                                                                ) : (
                                                                    step.stepType === STEP_TYPE.PAUSE ? (
                                                                        <div className='speech hang'>
                                                                            <div className='pause' onClick={editSegment(seg, lang, step, '', indx)}>
                                                                                <img src={pauseTypeIcon} alt="" />Pause
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        step.stepType === STEP_TYPE.LISTEN_ANYTHING || step.stepType === STEP_TYPE.LISTEN_BETA || step.stepType === STEP_TYPE.LISTEN_CONTEXT_ALIGNMENT ? (

                                                                            <div onClick={editSegment(seg, lang, step, '', indx)} >
                                                                                <div className={'prompt flex listen-anything'}>
                                                                                    <img src={phoneIcon} alt="" className="absolute top-15" />
                                                                                    <div className='f-w-500 pl-30'>
                                                                                        {step.stepType === STEP_TYPE.LISTEN_ANYTHING ? 'Listen Anything' : step.stepType === STEP_TYPE.LISTEN_BETA ? `Listen v2 (${(step.comparisonMode === 'waveform' || step.comparison_mode === 'waveform') ? 'Waveform' : 'Transcription'})` : 'Listen Context Alignment'}
                                                                                        {step.stepType === STEP_TYPE.LISTEN_CONTEXT_ALIGNMENT && step.prompt ? (
                                                                                            <>
                                                                                                {step.prompt.includes('|') ? (
                                                                                                    <>
                                                                                                        <span className='f-w-400 db'><strong>Description:</strong> {step.prompt.split('|')[0]}</span>
                                                                                                        <span className='f-w-400 db'><strong>Example:</strong> {step.prompt.split('|')[1]}</span>
                                                                                                    </>
                                                                                                ) : (
                                                                                                    <span className='f-w-400 db'><strong>Description:</strong> {step.prompt}</span>
                                                                                                )}
                                                                                            </>
                                                                                        ) : step.stepType === STEP_TYPE.LISTEN_BETA ? (
                                                                                            <>
                                                                                                {(step.comparisonMode === 'waveform' || step.comparison_mode === 'waveform') ? (
                                                                                                    // Waveform mode: show audio file name
                                                                                                    step.libraryItemIds?.length ? (
                                                                                                        <span className='f-w-400 db'>
                                                                                                            <strong>Reference Audio:</strong> {step.libraryItemIds.map((item: any) => item.name).join(', ')}
                                                                                                        </span>
                                                                                                    ) : (
                                                                                                        <span className='f-w-400 db' style={{ fontStyle: 'italic', color: '#666' }}>
                                                                                                            No reference audio selected
                                                                                                        </span>
                                                                                                    )
                                                                                                ) : (
                                                                                                    // Transcription mode: show prompt text
                                                                                                    <span className='f-w-400 db'>{step.prompt}</span>
                                                                                                )}
                                                                                            </>
                                                                                        ) : (
                                                                                            <span className='f-w-400 db'>{step.prompt}</span>
                                                                                        )}
                                                                                    </div>

                                                                                </div>
                                                                            </div>

                                                                        ) : (
                                                                            <div className='speech' onClick={editSegment(seg, lang, step, '', indx)}>
                                                                                <div>
                                                                                    <div className={'prompt' + (step.stepType === STEP_TYPE.PLAY_AUDIO ? ' record-voice' : '')}>
                                                                                        <img src={step.stepType === STEP_TYPE.PLAY_AUDIO ? audioIcon : speakIcon} alt="" className="absolute top-15" />
                                                                                        <div className='f-w-500 pl-30'>
                                                                                            {t((step.stepType === STEP_TYPE.PLAY_AUDIO ? 'Play Audio' : step.stepType) || '')}<br />
                                                                                            
                                                                                            {findVariables(step.messageToPlay || '').map((msg,ind)=>(
                                                                                                <span onMouseEnter={loadVars(msg.msg)} title={varContents?.[msg.msg] || ''} key={`row_message_${ind}`} className='f-w-400 db'>
                                                                                                    {step?.testResult?.messageToPlay ? step?.testResult?.messageToPlay:msg.msg}
                                                                                                </span>
                                                                                            ))}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    )
                                                                )
                                                            )}

                                                            {step?.listenSubStep && (
                                                                <div className='flex segment-subs'>
                                                                    {step?.testResult?.voice?.listenSubstep && (
                                                                        <div onClick={editSegment(seg, lang, step, 'A', indx)} className={'branching ' + (runStatus !== TESTCASE_RUN_STATUS.NONE ? ' running' : '')}>
                                                                            {step.stepSeq}A
                                                                        </div>
                                                                    )}
                                                                    {step.listenSubStep.filter(ss => !step.testResult || ss.name !== step?.testResult?.voice?.listenSubstep).map((sub: ISegmentStep) => (
                                                                        <div onClick={editSegment(seg, lang, step, sub.name, indx)} className={'branching ' + (runStatus !== TESTCASE_RUN_STATUS.NONE ? ' running' : '')} key={`sub_render_${sub.name}`}>
                                                                            {step.stepSeq}{sub.name}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}

                                                            {[STEP_TYPE.LISTEN].includes(step.stepType || STEP_TYPE.NONE) && (
                                                                step?.testResult?.status === RUN_STATUS.SUCCESS ? (
                                                                    <div className="latency">Pass Latency: {((step?.testResult?.voice?.latency || 0) / 1000).toFixed(2)} s</div>
                                                                ) : (
                                                                    step?.testResult?.status === RUN_STATUS.FAILED && (
                                                                        <>
                                                                            {getTranscription(seg.testResult?.id, step.testResult?.id) && (
                                                                                <div className='prompt flex no-match'>
                                                                                    [Transcript] {getTranscription(seg.testResult?.id, step.testResult?.id)}
                                                                                </div>
                                                                            )}
                                                                            <div className="latency fail-color flex-center gap-8">
                                                                                <div>No Match</div>
                                                                                <img className='pl-20 pointer' src={currentAudioId === step.testResult?.id && playingAudio ? pauseIcon : playIcon} onClick={playTrans(step.testResult?.id)} alt="" />
                                                                                <img onClick={getFailedListenFile(seg, step, lang)} src={getTransIcon(seg.testResult?.id, step.testResult?.id)} alt="" className='pointer' />
                                                                            </div>
                                                                        </>
                                                                    )
                                                                )
                                                            )}
                                                            {step?.testResult?.voice?.agentResponse?.screenshot && (
                                                                <div className="agentResponse" onClick={downloadScreenshot(step?.testResult?.voice?.agentResponse?.screenshot)}>
                                                                    <img src={scessors} />
                                                                </div>
                                                            )}

                                                            {[STEP_TYPE.LISTEN_ANYTHING, STEP_TYPE.LISTEN_BETA, STEP_TYPE.LISTEN_CONTEXT_ALIGNMENT].includes(step.stepType || STEP_TYPE.NONE) && step?.testResult?.status === RUN_STATUS.SUCCESS && (
                                                                <>
                                                                    {getTranscription(seg.testResult?.id, step.testResult?.id) && (
                                                                        <div className='prompt flex no-match'>
                                                                            [Transcript] {getTranscription(seg.testResult?.id, step.testResult?.id)}
                                                                        </div>
                                                                    )}
                                                                    <div className="latency fail-color flex-center gap-8 pl-0">
                                                                        <div className="latency">Pass Latency: {((step?.testResult?.voice?.latency || 0) / 1000).toFixed(2)} s</div>
                                                                        <img className='pl-20 pointer' src={currentAudioId === step.testResult?.id && playingAudio ? pauseIcon : playIcon} onClick={playTrans(step.testResult?.id)} alt="" />
                                                                        <img onClick={getFailedListenFile(seg, step, lang)} src={getTransIcon(seg.testResult?.id, step.testResult?.id)} alt="" className='pointer' />
                                                                    </div>
                                                                </>
                                                            )}

                                                            {[STEP_TYPE.RECORD_VOICE].includes(step.stepType || STEP_TYPE.NONE) && step?.testResult?.status === RUN_STATUS.SUCCESS && (
                                                                <div className="latency fail-color flex-center gap-8 pl-0">
                                                                    <div className="latency">Pass Latency: {((step?.testResult?.voice?.latency || 0) / 1000).toFixed(2)} s</div>
                                                                    <img className='pl-20 pointer' src={currentAudioId === step.testResult?.attachmentUrl && playingAudio ? pauseIcon : playIcon} onClick={playAudioFile(step.testResult?.attachmentUrl || '')} alt="" />
                                                                </div>
                                                            )}

                                                        </div>
                                                    ))}

                                                </div>
                                                {seg.runStatus === RUN_STATUS.FAILED && (
                                                    <div className={'db seg-list mb-80 result-circle'}>
                                                        <div className='end failed'>STOP</div> <span>Failed</span>
                                                    </div>
                                                )}
                                            </SegmentItem>
                                        ))

                                ))}

                                {runStatus === TESTCASE_RUN_STATUS.FINISHED && (
                                    <div className='flex'>
                                        <div className={'db seg-list mb-80 end'}>
                                            END
                                        </div>
                                        <div className='passed-text'>PASS</div>

                                        {runStatus === TESTCASE_RUN_STATUS.FINISHED && project?.data?.channelType === CHANNELS.VOICE && (
                                            <div className='mos'>
                                                {lastRunResult?.testResult?.voice?.mos && (
                                                //     <p className='calc-mos'>Calculating MOS</p>
                                                // ) : (
                                                    <>
                                                        MOS {lastRunResult?.testResult?.voice?.mos}
                                                    </>
                                                )}

                                            </div>
                                        )}
                                    </div>
                                )}
                            </>
                        )}
                        </div>
                        {segments?.length > 0 && (
                            <div className='no-segment-bottom' ref={drop}>
                                <div className='db w-100 pt-40'><AddCircleOutlineIcon onClick={handleAddSegment} style={{ fill: '#7D6C6C', fontSize: '51px' }} /></div>
                                <div className='db w-100 pt-15'><Typography variant='caption'>{t('Add a segment')}</Typography></div>
                            </div>
                        )}
                    </Box>
                
                    
                    
                    <Box className="segment-editor-save-buttons">
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '30px', paddingTop: '21px', flexFlow: 'wrap' }}>
                            <Button
                                variant={'contained'}
                                color={!triggerSave ? "secondary" : "primary"}
                                className='max-h-30'
                                onClick={handleSave}
                                disabled={!triggerSave}
                            >
                                {t('Save')}
                            </Button>

                            {testCase?.name && (
                                <Button
                                variant={'contained'}
                                color={!triggerSave ? "secondary" : "primary"}
                                className='max-h-30'
                                onClick={handleSaveAsNew}
                                disabled={!triggerSave}
                                >
                                    {t('Save As New')}
                                </Button>
                            )}
                            

                            {testCase?.name && (
                              <Button
                              variant="contained"
                              color={
                                !(triggerSave && project?.data?.channelType === CHANNELS.VOICE) &&
                                segments?.length &&
                                runStatus === TESTCASE_RUN_STATUS.STARTED &&
                                activeRunEngine === 'nvp'
                                  ? 'error'
                                  : !(triggerSave && project?.data?.channelType === CHANNELS.VOICE) &&
                                    segments?.length &&
                                    [TESTCASE_RUN_STATUS.FINISHED, TESTCASE_RUN_STATUS.NONE, TESTCASE_RUN_STATUS.STOPPED].includes(runStatus)
                                  ? 'primary'
                                  : 'secondary'
                              }
                              className="max-h-30"
                              onClick={
                                runStatus === TESTCASE_RUN_STATUS.STARTED && activeRunEngine === 'nvp'
                                  ? abortTestCase
                                  : runTestCaseWithVariation('nvp')
                              }
                              disabled={
                                (triggerSave && project?.data?.channelType === CHANNELS.VOICE) ||
                                !segments?.length ||
                                (runStatus === TESTCASE_RUN_STATUS.STARTED && activeRunEngine !== 'nvp')
                              }
                            >
                              {t(
                                runStatus === TESTCASE_RUN_STATUS.STARTED && activeRunEngine === 'nvp'
                                  ? 'Abort'
                                  : 'Run'
                              )}
                            </Button>

                            )}


                            <Button
                                variant={"contained"}
                                color={lastRunResult && [TESTCASE_RUN_STATUS.FINISHED, TESTCASE_RUN_STATUS.NONE, TESTCASE_RUN_STATUS.STOPPED].includes(runStatus) ? "primary" : "secondary"}
                                className='max-h-30'
                                onClick={handleLastRunResult}
                                disabled={!lastRunResult}
                            >
                                {t('Detailed Run Result')}
                            </Button>
                        </div>
                    </Box>
                </div>
            </CardContent>
            
            <Modal 
                isOpen={openaddComment}
                title="Test Case Description"
                small={true}
                body={<div className='comment'>
                    <TextField
                    label="Description"
                    fullWidth
                    multiline
                    minRows={4}            // initial height
                    maxRows={12}           // max height before scrolling appears
                    value={formik.values.comment}
                    onChange={formik.handleChange}
                    style={{ backgroundColor: 'white' }}
                    name="comment"
                    />
                    <div className='flex-end mt-16'>
                        <Button variant="contained" color="primary" onClick={handleAddComment}>
                            {formik.values?.comment ? 'Update' : 'Add'} {/* Change text based on whether a comment exists */}
                        </Button>
                    </div>
                </div>}
                deleteConfirmation={false}  
                isShowwarning={Commentshowwarning}
                setCommentshowwarning={setCommentshowwarning}
                Icon="comment"
            />
            <Modal 
                isOpen={openaddNotes}
                title="Add Notes"
                small={true}
                body={
                 <div className='notes'>
                  <Richtexteditor
                        value={formik?.values?.notes} // Bind the value to formik's notes field
                        onChange={(content) => {
                            
                            formik.setFieldValue('notes', content); // Update formik's notes field
                            formik.handleChange({ target: { name: 'notes', value: content } }); // Trigger formik.handleChange
                         
                        }} // Update formik's notes field on change
                        style={{
                            height: '200px', // Set height for multiline input
                            marginBottom: '70px', // Add spacing below the editor
                        }}
                        placeholder="Write your notes here..."// Add a placeholder for better UX
                        readOnly={false} // Allow editing
                        
                    />
                    <div className='flex-end mt-16'>
                        <Button variant="contained" color="primary" onClick={handleAddNotes}>
                            {formik.values?.notes ? 'Update' : 'Add'}
                        </Button>
                    </div>
                 
                </div>
                
            }
                deleteConfirmation={false}    
                Icon="notes"     
                isShowwarning={Noteshowwarning}
                setNoteshowwarning={setNoteshowwarning}   
            />
                         
            <Modal
                isOpen={openReminder}
                title="Reminder"
                small={true}
                body={<div className='reminder'><CheckCircleOutlineIcon style={{ fontSize: '53px', color: '#58A148' }} /> <br />The Transcript has been copied to the clipboard.<br />
                    You can apply copied text to segment editor now.</div>}
                deleteConfirmation={false}
            />

           
            <Modal
                isOpen={runParameter}
                title="Run Parameter"
                small={true}
                body={
                    <div className='reminder'><InfoOutlinedIcon style={{ fontSize: '53px', color: '#FD5900' }} /> <br />{t('Total number of runs:')} {runAll ? iterationCount:1}<br /><br/>
                        <div className='run-param'>{t('DEFAULT')}<Switch onChange={setItCount} disabled={hasMultipleVariables} />{t('ALL')}</div>
                        {hasMultipleVariables && (
                            <div style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                                Multiple multi-value variables detected. Only DEFAULT execution is available.
                            </div>
                        )}
                        <br/>
                        {project?.data?.channelType !== CHANNELS.DIGITAL && <Box className="segment-editor-save-buttons">
                                    <Button
                                        variant={'contained'}
                                        color={'primary'}
                                        className='max-h-30'
                                        onClick={()=>{
                                            setRunParameter('');
                                            setHasMultipleVariables(false);
                                            setPendingRunEngine(null);
                                        }}
                                    >
                                        {t('Back')}
                                    </Button>
                                    <Button
                                        variant={'contained'}
                                        color={'primary'}
                                        className='max-h-30 ml-80'
                                        onClick={runTestCase(true, pendingRunEngine)}
                                    >
                                        {t('Run')}
                                    </Button>
                            </Box>
                        }
                        {project?.data?.channelType === CHANNELS.DIGITAL && (
                           <div className='db w-100'>
                                <div className='db'><h5>{t('Available Browsers:')}</h5></div>
                                {browsers?.map((b:any)=>(
                                    <div className='flex align-center gap-8 mt-24'>
                                        <Checkbox onChange={browserSelected} value={b.browserCode} /> {b.browserName} ({b.browserVersion})
                                    </div>
                                ))}
        
                                    <Box className="segment-editor-save-buttons mt-22 flex-end gap-8">
                                    <Button
                                        variant={'contained'}
                                        color={'primary'}
                                        className='max-h-30'
                                        onClick={()=>{
                                            setOpenSelectBrowser('');
                                            setRunParameter('');
                                            setHasMultipleVariables(false);
                                            setPendingRunEngine(null);
                                        }}
                                    >
                                        {t('Cancel')}
                                    </Button>
                                    <Button
                                        variant={'contained'}
                                        color={'primary'}
                                        className='max-h-30'
                                        onClick={runDigital}
                                    >
                                        {t('Run')}
                                    </Button>
                                </Box>
                            </div>
                        )}
                    </div>
                    
                }
                deleteConfirmation={false}
            />

                <Modal 
                  isOpen={openSelectBrowser}
                  title={t("Browser Selections")}
                  small={true}
                  body={
                    <div className='db w-100'>
                        <div className='db'><h5>{t('Available Browsers:')}</h5></div>
                        {browsers?.map((b:any)=>(
                            <div className='flex align-center gap-8 mt-24'>
                               <Checkbox onChange={browserSelected} value={b.browserCode} /> {b.browserName} ({b.browserVersion})
                            </div>
                        ))}

                         <Box className="segment-editor-save-buttons mt-22 flex-end gap-8">
                            <Button
                                variant={'contained'}
                                color={'primary'}
                                className='max-h-30'
                                onClick={()=>setOpenSelectBrowser('')}
                            >
                                {t('Cancel')}
                            </Button>
                            <Button
                                variant={'contained'}
                                color={'primary'}
                                className='max-h-30'
                                onClick={runDigital}
                            >
                                {t('Run')}
                            </Button>
                        </Box>
                    </div>
                  }
                  />
        </Card>
    );
};
